// AwaitingReportService.ts
import axios from 'axios';
import { axiosRequest } from './AxiosService';
import { AwaitingReportResponse,AwaitingReportResponseList } from '../type/response/AwaitingReportResponse';  
import {AwaitingReportType } from '../pages/AwaitingReport/data/AwaitingReportType';  
import dayjs from 'dayjs';

/**
 * 報告待ち一覧データを取得し、表示用の形式に変換して返す
 * @returns 報告待ち一覧データ、取得失敗時は空配列
 */
export const getAwaitingReportData = async (): Promise<AwaitingReportType[]> => {
  try {
    const response = await axiosRequest<AwaitingReportResponseList>(
      "/awaitingReport", 
      "GET",
    );

    if (!Array.isArray(response)) {
      console.error("予期しないAPIレスポンス形式です:", response);
      return [];
    }
    
    // サーバーから取得したデータのフォーマットを変更する
    const formattedReporterOverviews: AwaitingReportType[] = response.map((awaitingReportResponse:AwaitingReportResponse)=>{
      const formattedReporterOverview:AwaitingReportType={
      id: awaitingReportResponse.applicationEntry.id,
      applicationNumber: awaitingReportResponse.applicationEntry.number,
      submittedAt: awaitingReportResponse.applicationEntry.submittedAt,  // 申請日
      applicationType: awaitingReportResponse.applicationType.name || "", // 申請種別
      applicationFormat: awaitingReportResponse.application.name || "", // 申請書
      description:awaitingReportResponse.application.description || "", // 申請書小分類
      applicationStatus: awaitingReportResponse.applicationEntry.status, // ステータス
      applicant: `${awaitingReportResponse.user.lastName}${awaitingReportResponse.user.firstName}`, // 申請者
      isUrgent: awaitingReportResponse.applicationEntry.isExpress, // 急ぎ申請か否か
      userProfiles: Array.isArray(awaitingReportResponse.userProfiles) //ユーザプロファイル
      ? awaitingReportResponse.userProfiles.map(profile => ({
          key: profile.key,
          value: profile.value
        })) : [] ,
      activities: Array.isArray(awaitingReportResponse.activities)
        ? awaitingReportResponse.activities.map(act => ({
            id: act.id,
            activityStatus: act.status,
            activityName: act.applicationActivity.activityName,
            endAt: act.endAt,
            order: act.applicationActivity.activityOrder,
            code:act.applicationActivity.code,
            reporterIds:act.reporterIds ?? [],
            reportedIds:act.reportedIds ?? []
          }))
        : []
        };

      return formattedReporterOverview;
    });
    
    return formattedReporterOverviews;
  
  }catch (error) {
    console.error("報告待ち一覧データの取得・整形に失敗しました:", error);
    return []; 
  }
};